import React, { useMemo } from "react";
import GenericListPage from "../../pages/GenericListPage";

const BusinessAdminUsersPage = () => {
  const columns = useMemo(() => [
    { header: "Name", key: "name" },
    { header: "Email", key: "email" },
    { header: "Role", key: "role" },
    { header: "Status", key: "status" },
    { header: "Organization", key: "organizationName" },
    { header: "Created", key: "createdAt", render: (item) => new Date(item.createdAt).toLocaleString() },
  ], []);

  return (
    <GenericListPage
      title="All Users"
      entityEndpoint="business-admin/users"
      columns={columns}
      hideActions={true}
      filterConfig={[
        { label: "Email", name: "email", type: "text", placeholder: "Search by email" },
        { label: "Organization", name: "organizationName", type: "text", placeholder: "Organization" },
      ]}
    />
  );
};

export default BusinessAdminUsersPage;